import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

export const echo = new Echo({
    broadcaster: process.env.VUE_APP_SOCKET_BROADCASTER,
    key: process.env.VUE_APP_PUSHER_KEY,
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    forceTLS: process.env.VUE_APP_FORCETLS,
    // enabledTransports: ['ws', 'wss'],
    // disableStats: true,
});
